import { render } from "./InputNumber.vue?vue&type=template&id=723ead57&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=ts"
export * from "./InputNumber.vue?vue&type=script&lang=ts"

import "./InputNumber.vue?vue&type=style&index=0&id=723ead57&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-723ead57"

export default script